import dotProp from 'dot-prop-immutable';
import * as types from 'live/redux/actionTypes';

const defaultState = {
  error: undefined,
  game: undefined,
  loading: false,
};

const selectedGameReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case types.LIVE_GAME_SET: {
      const game = action.payload;

      return dotProp.set(defaultState, 'game', game);
    }

    case types.LIVE_GAME_DELETE_REQUEST: {
      return {
        ...state,
        error: undefined,
        loading: true,
      };
    }

    case types.LIVE_GAME_DELETE_RECEIVE: {
      return { ...defaultState };
    }

    case types.LIVE_GAME_DELETE_ERROR: {
      const error = action.payload;

      return {
        ...state,
        error: error.message,
        loading: false,
      };
    }

    default:
      return state;
  }
};

export default selectedGameReducer;
